// FUNTION OF COOKIE

import Cookies from 'universal-cookie'

const   cookies = new Cookies(),
        cookie = {
            addCookie: (CookiePolicy, setCookiePolicy) => {
                cookies.set(CookiePolicy, setCookiePolicy, { path: '/' })
            },

            removeCookie: (CookiePolicy) => {
                cookies.remove(CookiePolicy)
            },

            getCookie: (CookiePolicy) => {
                cookies.get(CookiePolicy)
            }
        }

export default cookie